<template>
  <div class="bc__ui__barchart" :class="{'type--mini': this.blocks.length < 3}">
      <div class="barchart__container">
          <div v-for="(block, i) in this.blocks" :key="i"
               class="block__container"
               :class="['block__container--' + block.logo_name, {'blocked--height': !flagMounted}]"
               :style="{'height': (percs[i] * 100) + '%'}"
          >
              <span class="block__left" :class="'bglight1x--' + block.logo_name"></span>
              <span class="block__right" :class="'bg--' + block.logo_name"></span>
              <span class="block__tap" :class="'bglight2x--' + block.logo_name"></span>
              <span class="block__shadow"></span>
              <img :src="'/crop/pic/tblack/' + block.logo_name" :class="'bg--' + block.logo_name">
          </div>
          <a href="/parcels/first" @click="trackNewCrop" v-if="this.blocks.length === 1" class="block__container type--ghost">
              <span class="block__left"></span>
              <span class="block__right"></span>
              <span class="block__tap"></span>
              <span class="block__shadow"></span>
              <i class="icon-bc-plus"></i>
          </a>
      </div>
  </div>
</template>

<style lang="scss" scoped >

</style>

<script>
export default {

    props: [
        'blocks',
    ],

    data() {
        return {
            flagMounted: false,
            percs: this.blocks.map(() => 0),
        };
    },

    mounted() {
        this.flagMounted = true;

        setTimeout(() => {
            this.percs = this.blocks.map(b => b.perc);
        }, 200);
    },

    methods: {
        trackNewCrop() {
            window.mixpanel.track('New Crop', {
                origin: 'dashboard_widget'
            });
        }
    }
};

</script>
